import React from 'react'
// import { FormComponent } from '../../form/DynamicForm';
// import { Form } from '../../form/DynamicFormTs';
import Http from '../../Http';
import { FormComponent } from '../../components/form/DynamicForm';
import { Form } from '../../components/form/DynamicFormTs';

export default class Personalizacion extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'prop/user', saveUrl: 'prop/user', backUrl: '/Catalogo/User' },
      new Form([
        Form.Field('text', 'nombre_sistema', 'Nombre del sistema', '', [], 6),
        Form.Field('file', 'logo', 'Logo', '', [], 6),
        Form.Field('color', 'color_1', 'Color primario', '', [], 6),
        Form.Field('color', 'color_2', 'Color secundario', '', [], 6),
      ], ['Guardar'], 'Personalizar'), this.formData
    )
    this.LoadPreds();
  }

  LoadPreds = async () => {
    let Res = await Http.get(`prop/user`);
    console.log(Res);
    if (!Res.error)
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
  }

  onSubmit = async (i, vals) => {
    try {
      this.setState({ loading: true });
      console.log(vals)
      let postData = new FormData();
      postData.append('logo', vals.logo && vals.logo.length > 0 ? vals.logo[0] : null);
      postData.append('nombre_sistema', vals.nombre_sistema);
      postData.append('color_1', vals.color_1);
      postData.append('color_2', vals.color_2);
      let Res = await Http.post('prop/user/save', postData);
      if(!Res.error) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ minWidth: '100%', padding: '5px' }} >
        <this.FormRender {...this.props} />
      </div>
    )
  }
}
